<script>
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "MiniButton",
    mixins: [emCommonUtilMixin],
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        disable: {
            type: Boolean,
            default: false
        },
        loadingType: {
            type: String,
            default: 'border'
        },
        variant: {
            type: String,
            default: 'outline-primary'
        },
        confirmText: String,
        name: String,
        thin: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        btnId() {
            return this.genNonDuplicateID(6);
        },
    },
    methods: {
        whenClick() {
            if (this.confirmText) {
                this.confirmClick();
            } else {
                this.emitClick();
            }
        },
        confirmClick() {
            this.$emit('confirming');
            this.$bvModal.msgBoxConfirm(this.confirmText, {
                title: '提醒',
                headerBgVariant: 'light',
                headerClass: 'text-dark',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: '是',
                cancelTitle: '否',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }).then(confirm => {
                if (confirm) {
                    this.emitClick();
                } else {
                    this.$emit('noConfirm')
                }
            });
        },
        emitClick() {
            this.$emit('btnClick');
            this.$emit('click');
            this.logInteraction();
        },
        async logInteraction() {
            let btnLabel = this.name || document.getElementById(this.btnId).innerText;
            if (this.hasCode(btnLabel)) {
                this.$interaction({
                    identifyCode: 'mini-button',
                    actionName: 'btn-click',
                    actionContent: btnLabel
                });
            }
        },
    }
}
</script>

<template>
    <b-button :id="btnId"
              :variant="variant"
              :disabled="loading || disable"
              :class="thin?'thin':''"
              :title="name"
              @click="whenClick">
        <b-spinner small v-if="loading" :type="loadingType"></b-spinner>
        <slot></slot>
    </b-button>
</template>

<style scoped>
.thin {
    padding: .1rem .2rem !important;
}
</style>
